import type { User } from "../services/backendTypes";

/**
 * Enum for all available feature flags in the application
 * Add new feature flags here to maintain type safety
 */
export enum FeatureFlag {
  FF_FEMALE_HORMONES = "FF_FEMALE_HORMONES",
  FF_COPY_MEALS_TO_ANOTHER_DAY = "FF_COPY_MEALS_TO_ANOTHER_DAY",
  FF_B2C_PAYWALL = "FF_B2C_PAYWALL",
  FF_PLANT_BASED_APP = "FF_PLANT_BASED_APP",
  FF_DISABLE_LOW_CARB_OPTION = "FF_DISABLE_LOW_CARB_OPTION",
  FF_RECIPE_INSPIRATION = "FF_RECIPE_INSPIRATION",
  FF_FEMALE_HORMONES_MENOPAUSE_ONLY = "FF_FEMALE_HORMONES_MENOPAUSE_ONLY",
  FF_DISABLE_KETO_OPTION = "FF_DISABLE_KETO_OPTION",
}

/**
 * Checks if a feature flag is active for a given user
 * @param user The user to check
 * @param flag The feature flag to check
 * @returns boolean indicating if the flag is active
 */
export function isFeatureFlagActive(user: User | null, flag: FeatureFlag): boolean {
  if (!user || !user.feature_flags_for_user) {
    return false;
  }

  const { flags, switches, samples } = user.feature_flags_for_user;

  // Check if the flag exists in any of the three collections
  return flags.includes(flag) || switches.includes(flag) || samples.includes(flag);
}

/**
 * Creates a features object for the FlagProvider based on the user's feature flags
 * @param user The user to check feature flags for
 * @returns Record of feature flags and their active status
 */
export function createFeaturesObject(user: User | null): Record<string, boolean> {
  return Object.values(FeatureFlag).reduce(
    (acc, flag) => ({
      ...acc,
      [flag]: isFeatureFlagActive(user, flag as FeatureFlag),
    }),
    {} as Record<string, boolean>
  );
}
